import { motion, useInView } from "framer-motion";
import { useRef } from "react";

import googleAds from "@/assets/social/google-ads.png";
import shopify from "@/assets/social/shopify.png";
import meta from "@/assets/social/meta.png";
import googleAnalytics from "@/assets/social/google-analytics.png";
import hubspot from "@/assets/social/hubspot.png";
import salesforce from "@/assets/social/salesforce.png";
import n8n from "@/assets/social/n8n.png";
import openai from "@/assets/social/openai.png";
import tiendanube from "@/assets/social/tiendanube.png";
import tiktokAds from "@/assets/social/tiktok-ads.png";

const logos = [
  { name: "Google Ads", src: googleAds },
  { name: "Shopify", src: shopify },
  { name: "Meta", src: meta },
  { name: "Google Analytics", src: googleAnalytics },
  { name: "HubSpot", src: hubspot },
  { name: "Salesforce", src: salesforce },
  { name: "n8n", src: n8n },
  { name: "OpenAI", src: openai },
  { name: "Tiendanube", src: tiendanube },
  { name: "TikTok Ads", src: tiktokAds },
];

const SocialProofBar = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const items = [...logos, ...logos, ...logos];

  return (
    <section className="py-10 bg-foreground overflow-hidden" ref={ref}>
      <motion.div
        className="flex w-max items-center"
        initial={{ opacity: 0, x: 100 }}
        animate={inView ? { opacity: 1, x: 0 } : {}}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        style={{ animation: inView ? "socialproof-scroll 40s linear infinite" : "none" }}
      >
        {items.map((logo, i) => (
          <motion.div
            key={`${logo.name}-${i}`}
            className="flex-shrink-0 mx-12 md:mx-16 flex items-center justify-center"
            style={{ width: 340, height: 130 }}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={inView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.5, delay: Math.min(i * 0.05, 0.5) }}
          >
            <img
              src={logo.src}
              alt={logo.name}
              className="max-h-[130px] max-w-[340px] w-auto h-auto object-contain opacity-60 hover:opacity-90 transition-opacity duration-300 scale-150"
              loading="lazy"
            />
          </motion.div>
        ))}
      </motion.div>
      <style>{`
        @keyframes socialproof-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
      `}</style>
    </section>
  );
};

export default SocialProofBar;
